import { Injectable } from '@angular/core';
import { LoggerService } from '@app/logger/logger.service';
import { ApiBaseService } from './api-base.service';

const log = new LoggerService('SUPPLIES SERVICE');

@Injectable({
  providedIn: 'root'
})
export class SuppliesService extends ApiBaseService<any>{

  constructor() {
    // Recurso del catálogo de Insumos (lo que usa el paciente)
    super('supplies');
    log.debug('Servicio de Insumos inicializado');
  }

}
